var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import moment from 'moment';
import { useIntl, defineMessages } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import CountrySelect from '@/shared/components/input/CountrySelect';
import DatePicker from '@/shared/components/input/DatePicker';
import Checkbox from '@/shared/components/input/Checkbox';
import EnumSelect from '@/shared/components/input/EnumSelect';
import { ensureMoment, toISODate } from '@/shared/utils/dateHelper';
import { useCreateLegalEntity, } from '@/shared/hooks/legalEntity/useCreateLegalEntity';
import legalEntityMessages from '../legalEntitiesMessages';
import generalSettingsMessages from '@/modules/settings/GeneralSettings/generalSettingsMessages';
var messages = defineMessages({
    AddLegalEntity: { id: 'AddLegalEntity', defaultMessage: 'Add legal entity' },
    Street: { id: 'Street', defaultMessage: 'Street' },
    Number: { id: 'No.', defaultMessage: 'No.' },
    Box: { id: 'Box', defaultMessage: 'Box' },
    Street2: { id: 'Street2', defaultMessage: 'Street 2' },
    PostalCode: { id: 'PostalCode', defaultMessage: 'Postal code' },
    City: { id: 'City', defaultMessage: 'City' },
    Country: { id: 'Country', defaultMessage: 'Country' },
    StartCurrentBookyear: {
        id: 'StartCurrentBookyear',
        defaultMessage: 'Start current bookyear',
    },
    StartNextBookyear: {
        id: 'StartNextBookyear',
        defaultMessage: 'Start next bookyear',
    },
    AddFormatParts: { id: 'AddFormatParts', defaultMessage: 'Add format parts' },
    Yy: { id: '[Yy]', defaultMessage: '[Yy]' },
    Yyyy: { id: '[Yyyy]', defaultMessage: '[Yyyy]' },
    Mm: { id: '[Mm]', defaultMessage: '[Mm]' },
    Counter: { id: '[Counter:Nx]', defaultMessage: '[Counter:Nx]' },
    Text: { id: 'Text', defaultMessage: 'Text' },
    CounterLabel: { id: 'CounterLabel', defaultMessage: 'Counter #' },
    YearTitle: { id: 'Year', defaultMessage: 'Year' },
    MonthTitle: { id: 'MonthTitle', defaultMessage: 'Month of the invoice date' },
    InvoiceCounterTitle: { id: 'InvoiceCounterTitle', defaultMessage: 'Invoice counter' },
    FreeTextTitle: { id: 'FreeTextTitle', defaultMessage: 'Free text' },
});
var emptyAddress = {
    id: null,
    street1: '',
    street2: '',
    number: '',
    box: '',
    zipCode: '',
    city: '',
    region: null,
    country: null,
};
var parseNumberFormat = function (format) {
    var elements = [];
    if (!format)
        return elements;
    var part = '';
    var inBlock = false;
    for (var i = 0; i < format.length; i++) {
        var c = format[i];
        if (!inBlock && c === '[') {
            inBlock = true;
            if (part !== '') {
                elements.push({ id: 'Text', t: part });
                part = '';
            }
        }
        else if (inBlock && c === ']') {
            inBlock = false;
            var lower = part.toLowerCase();
            if (lower === 'yyyy')
                elements.push({ id: 'Yyyy', n: 0 });
            else if (lower === 'yy')
                elements.push({ id: 'Yy', n: 0 });
            else if (lower === 'mm')
                elements.push({ id: 'Mm', n: 0 });
            else {
                var n = parseInt(lower.replace('counter:n', '').trim(), 10);
                if (Number.isInteger(n))
                    elements.push({ id: 'Counter', n: n });
            }
            part = '';
        }
        else {
            part += c;
        }
    }
    if (part !== '')
        elements.push({ id: 'Text', t: part });
    return elements;
};
var serializeElements = function (elements) {
    return elements.reduce(function (result, el) {
        if (el.id === 'Text')
            return result + (el.t || '');
        if (el.id === 'Counter')
            return result + "[Counter:N".concat(el.n || 0, "]");
        return result + "[".concat(el.id, "]");
    }, '');
};
var generateExample = function (elements, startDate, counter) {
    if (!elements.length)
        return null;
    var date = startDate ? moment.utc(startDate).toDate() : moment.utc().toDate();
    var yyyy = date.getFullYear();
    var yy = String(yyyy).slice(-2);
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var ctr = counter && parseInt(String(counter), 10) > 0 ? parseInt(String(counter), 10) : 1;
    return elements.reduce(function (result, el) {
        if (el.id === 'Text')
            return result + el.t;
        if (el.id === 'Counter')
            return result + String(ctr).padStart(el.n, '0');
        if (el.id === 'Yyyy')
            return result + String(yyyy);
        if (el.id === 'Yy')
            return result + yy;
        if (el.id === 'Mm')
            return result + mm;
        return result;
    }, '');
};
var BookyearFormatBuilder = function (_a) {
    var value = _a.value, startDate = _a.startDate, firstNumber = _a.firstNumber, onChange = _a.onChange;
    var intl = useIntl();
    // Hold elements as local state — round-tripping through serialize → parent → parse drops
    // empty parts (e.g. a freshly added Text element with no characters yet).
    var _b = useState(function () { return parseNumberFormat(value); }), elements = _b[0], setElements = _b[1];
    var hasCounter = elements.some(function (el) { return el.id === 'Counter'; });
    var update = function (next) {
        setElements(next);
        onChange(serializeElements(next));
    };
    var addPart = function (type) {
        if (type === 'Counter' && hasCounter)
            return;
        var newEl;
        if (type === 'Text')
            newEl = { id: 'Text', t: '' };
        else if (type === 'Counter')
            newEl = { id: 'Counter', n: 0 };
        else
            newEl = { id: type, n: 0 };
        update(__spreadArray(__spreadArray([], elements, true), [newEl], false));
    };
    var removePart = function (index) { return update(elements.filter(function (_, i) { return i !== index; })); };
    var updatePart = function (index, patch) {
        return update(elements.map(function (el, i) { return (i === index ? __assign(__assign({}, el), patch) : el); }));
    };
    var movePart = function (from, to) {
        var updated = __spreadArray([], elements, true);
        var moved = updated.splice(from, 1)[0];
        updated.splice(to, 0, moved);
        update(updated);
    };
    return (_jsxs("div", __assign({ className: "numberFormatForm" }, { children: [_jsx("label", __assign({ className: "margin10R form-control-static" }, { children: intl.formatMessage(messages.AddFormatParts) })), _jsxs("div", __assign({ className: "btn-group", role: "group" }, { children: [_jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () { return addPart('Yy'); }, title: intl.formatMessage(messages.YearTitle) }, { children: intl.formatMessage(messages.Yy) })), _jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () { return addPart('Yyyy'); }, title: intl.formatMessage(messages.YearTitle) }, { children: intl.formatMessage(messages.Yyyy) })), _jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () { return addPart('Mm'); }, title: intl.formatMessage(messages.MonthTitle) }, { children: intl.formatMessage(messages.Mm) })), !hasCounter && (_jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () { return addPart('Counter'); }, title: intl.formatMessage(messages.InvoiceCounterTitle) }, { children: intl.formatMessage(messages.Counter) }))), _jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () { return addPart('Text'); }, title: intl.formatMessage(messages.FreeTextTitle) }, { children: intl.formatMessage(messages.Text) }))] })), _jsx("div", __assign({ className: "dropzone" }, { children: elements.map(function (el, index) {
                    var _a;
                    return (_jsxs("div", __assign({ className: "bold part", style: { display: 'inline-block', margin: 2 } }, { children: [el.id === 'Yy' && _jsx("span", __assign({ className: "bold margin5R" }, { children: "[Yy]" })), el.id === 'Yyyy' && _jsx("span", __assign({ className: "bold margin5R" }, { children: "[Yyyy]" })), el.id === 'Mm' && _jsx("span", __assign({ className: "bold margin5R" }, { children: "[Mm]" })), el.id === 'Counter' && (_jsx("span", __assign({ className: "bold margin5R" }, { children: intl.formatMessage(messages.CounterLabel) }))), _jsxs("span", __assign({ style: { display: 'inline-block', margin: '0 4px' } }, { children: [el.id === 'Text' && (_jsx("input", { type: "text", className: "input-sm", size: 10, value: el.t || '', onChange: function (e) { return updatePart(index, { t: e.target.value }); } })), el.id === 'Counter' && (_jsx("input", { type: "number", className: "input-sm", min: 0, max: 9, style: { minWidth: 45 }, value: (_a = el.n) !== null && _a !== void 0 ? _a : 0, onChange: function (e) { return updatePart(index, { n: parseInt(e.target.value, 10) || 0 }); } }))] })), index > 0 && (_jsx("a", __assign({ className: "clickable margin5R", onClick: function () { return movePart(index, index - 1); } }, { children: _jsx("i", { className: "fa fa-arrow-left" }) }))), index < elements.length - 1 && (_jsx("a", __assign({ className: "clickable margin5R", onClick: function () { return movePart(index, index + 1); } }, { children: _jsx("i", { className: "fa fa-arrow-right" }) }))), _jsx("a", __assign({ className: "clickable", onClick: function () { return removePart(index); } }, { children: _jsx("i", { className: "fa fa-times" }) }))] }), index));
                }) })), _jsxs("div", { children: [_jsx("span", { children: intl.formatMessage(generalSettingsMessages.Example) }), ":\u00A0", _jsx("span", __assign({ className: "bold" }, { children: generateExample(elements, startDate, firstNumber) }))] })] })));
};
var buildDefaultCurrentBookyear = function () { return ({
    startDate: moment
        .utc()
        .startOf('year')
        .toISOString(),
    invoiceNumberFormat: '[Yy][Counter:N4]',
    creditNoteNumberFormat: '[Yy][Counter:N4]',
    invoiceNumberStartValue: 1,
    creditNoteNumberStartValue: 1,
    separateCounterCreditNotes: false,
}); };
var isFormatValid = function (format) {
    return parseNumberFormat(format || '').some(function (el) { return el.id === 'Counter'; });
};
var CreateLegalEntityModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, onSaved = _a.onSaved;
    var intl = useIntl();
    var _b = useCreateLegalEntity(), createLegalEntity = _b.createLegalEntity, isLoading = _b.isLoading;
    var _c = useState(''), name = _c[0], setName = _c[1];
    var _d = useState(emptyAddress), address = _d[0], setAddress = _d[1];
    var _e = useState(1), numberFormatYear = _e[0], setNumberFormatYear = _e[1];
    var _f = useState(buildDefaultCurrentBookyear), currentBookyear = _f[0], setCurrentBookyear = _f[1];
    var _g = useState(moment
        .utc()
        .startOf('year')
        .add(1, 'year')
        .toISOString()), nextBookyearStartDate = _g[0], setNextBookyearStartDate = _g[1];
    var _h = useState(false), currentDateFocused = _h[0], setCurrentDateFocused = _h[1];
    var _j = useState(false), nextDateFocused = _j[0], setNextDateFocused = _j[1];
    var updateAddress = function (field, value) {
        setAddress(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
    };
    var updateCurrent = function (key, value) {
        return setCurrentBookyear(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var isValid = useMemo(function () {
        return !!name.trim() &&
            !!currentBookyear.startDate &&
            !!nextBookyearStartDate &&
            isFormatValid(currentBookyear.invoiceNumberFormat) &&
            isFormatValid(currentBookyear.creditNoteNumberFormat) &&
            currentBookyear.invoiceNumberStartValue >= 1 &&
            currentBookyear.creditNoteNumberStartValue >= 1 &&
            new Date(nextBookyearStartDate) > new Date(currentBookyear.startDate);
    }, [name, currentBookyear, nextBookyearStartDate]);
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nextBookyear, created, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!isValid)
                        return [2 /*return*/];
                    nextBookyear = {
                        startDate: nextBookyearStartDate,
                        invoiceNumberFormat: currentBookyear.invoiceNumberFormat,
                        creditNoteNumberFormat: currentBookyear.creditNoteNumberFormat,
                        invoiceNumberStartValue: 1,
                        creditNoteNumberStartValue: 1,
                        separateCounterCreditNotes: currentBookyear.separateCounterCreditNotes,
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createLegalEntity({
                            name: name.trim(),
                            street1: address.street1,
                            street2: address.street2,
                            number: address.number,
                            box: address.box,
                            zipCode: address.zipCode,
                            city: address.city,
                            region: (_b = address.region) !== null && _b !== void 0 ? _b : null,
                            countryCode: address.country,
                            numberFormatYear: numberFormatYear,
                            currentBookyear: currentBookyear,
                            nextBookyear: nextBookyear,
                        })];
                case 2:
                    created = _c.sent();
                    onSaved(created);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.AddLegalEntity), show: show, onClose: onClose, onSave: handleSave, disabled: isLoading || !isValid, size: "lg" }, { children: _jsxs("div", __assign({ className: "form-horizontal", role: "form" }, { children: [_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "legalEntityName", className: "col-sm-3 control-label" }, { children: intl.formatMessage(legalEntityMessages.Name) })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx("input", { type: "text", id: "legalEntityName", className: "form-control", value: name, onChange: function (e) { return setName(e.target.value); }, placeholder: intl.formatMessage(legalEntityMessages.Name), autoFocus: true }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "col-sm-3 control-label" }, { children: intl.formatMessage(legalEntityMessages.Address) })), _jsxs("div", __assign({ className: "col-sm-9" }, { children: [_jsxs("div", __assign({ style: { display: 'flex', gap: 4, marginBottom: 4 } }, { children: [_jsx("input", { type: "text", className: "form-control", style: { flex: 3 }, placeholder: intl.formatMessage(messages.Street), value: address.street1, onChange: function (e) { return updateAddress('street1', e.target.value); } }), _jsx("input", { type: "text", className: "form-control", style: { flex: 1 }, placeholder: intl.formatMessage(messages.Number), value: address.number, onChange: function (e) { return updateAddress('number', e.target.value); } }), _jsx("input", { type: "text", className: "form-control", style: { flex: 1 }, placeholder: intl.formatMessage(messages.Box), value: address.box, onChange: function (e) { return updateAddress('box', e.target.value); } })] })), _jsx("input", { type: "text", className: "form-control", style: { marginBottom: 4 }, placeholder: intl.formatMessage(messages.Street2), value: address.street2, onChange: function (e) { return updateAddress('street2', e.target.value); } }), _jsxs("div", __assign({ style: { display: 'flex', gap: 4, marginBottom: 4 } }, { children: [_jsx("input", { type: "text", className: "form-control", style: { flex: 2 }, placeholder: intl.formatMessage(messages.PostalCode), value: address.zipCode, onChange: function (e) { return updateAddress('zipCode', e.target.value); } }), _jsx("input", { type: "text", className: "form-control", style: { flex: 3 }, placeholder: intl.formatMessage(messages.City), value: address.city, onChange: function (e) { return updateAddress('city', e.target.value); } })] })), _jsx(CountrySelect, { value: address.country, onChange: function (code) { return updateAddress('country', code); }, placeholder: intl.formatMessage(messages.Country) })] }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "col-sm-3 control-label" }, { children: intl.formatMessage(messages.StartCurrentBookyear) })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx(DatePicker, { id: "legalEntityCurrentBookyearStartDate", placeholder: intl.formatMessage(messages.StartCurrentBookyear), date: ensureMoment(currentBookyear.startDate), onDateChange: function (date) {
                                    return updateCurrent('startDate', date ? toISODate(date) : '');
                                }, focused: currentDateFocused, onFocusChange: function (_a) {
                                    var focused = _a.focused;
                                    return setCurrentDateFocused(focused);
                                }, isOutsideRange: function () { return false; }, block: true }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "col-sm-3 control-label" }, { children: intl.formatMessage(messages.StartNextBookyear) })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx(DatePicker, { id: "legalEntityNextBookyearStartDate", placeholder: intl.formatMessage(messages.StartNextBookyear), date: ensureMoment(nextBookyearStartDate), onDateChange: function (date) {
                                    return setNextBookyearStartDate(date ? toISODate(date) : '');
                                }, focused: nextDateFocused, onFocusChange: function (_a) {
                                    var focused = _a.focused;
                                    return setNextDateFocused(focused);
                                }, isOutsideRange: function () { return false; }, block: true }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "col-sm-3 control-label" }, { children: intl.formatMessage(generalSettingsMessages.SeparateCounterCreditNotes) })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx(Checkbox, { value: !!currentBookyear.separateCounterCreditNotes, onClick: function (value) { return updateCurrent('separateCounterCreditNotes', value); } }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "col-sm-3 control-label" }, { children: intl.formatMessage(generalSettingsMessages.InvoiceNumberStartValue) })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx("input", { type: "number", className: "form-control input-sm", style: { width: 100 }, min: 1, value: currentBookyear.invoiceNumberStartValue, onChange: function (e) {
                                    return updateCurrent('invoiceNumberStartValue', parseInt(e.target.value, 10) || 1);
                                } }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "col-sm-3 control-label" }, { children: intl.formatMessage(generalSettingsMessages.CreditNoteNumberStartValue) })), _jsx("div", __assign({ className: "col-sm-9" }, { children: currentBookyear.separateCounterCreditNotes ? (_jsx("input", { type: "number", className: "form-control input-sm", style: { width: 100 }, min: 1, value: currentBookyear.creditNoteNumberStartValue, onChange: function (e) {
                                    return updateCurrent('creditNoteNumberStartValue', parseInt(e.target.value, 10) || 1);
                                } })) : (_jsx("span", __assign({ className: "form-control-static" }, { children: currentBookyear.invoiceNumberStartValue }))) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsxs("label", __assign({ className: "col-sm-3 control-label" }, { children: [intl.formatMessage(generalSettingsMessages.InvoiceNumberFormat), !isFormatValid(currentBookyear.invoiceNumberFormat) && (_jsx("i", { className: "fa fa-exclamation-triangle fa-fw text-danger margin5L", title: intl.formatMessage(generalSettingsMessages.InvoiceCounterRequiredWarning) }))] })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx(BookyearFormatBuilder, { value: currentBookyear.invoiceNumberFormat, startDate: currentBookyear.startDate, firstNumber: currentBookyear.invoiceNumberStartValue, onChange: function (v) { return updateCurrent('invoiceNumberFormat', v); } }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsxs("label", __assign({ className: "col-sm-3 control-label" }, { children: [intl.formatMessage(generalSettingsMessages.CreditNoteNumberFormat), !isFormatValid(currentBookyear.creditNoteNumberFormat) && (_jsx("i", { className: "fa fa-exclamation-triangle fa-fw text-danger margin5L", title: intl.formatMessage(generalSettingsMessages.CreditNoteCounterRequiredWarning) }))] })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx(BookyearFormatBuilder, { value: currentBookyear.creditNoteNumberFormat, startDate: currentBookyear.startDate, firstNumber: currentBookyear.separateCounterCreditNotes
                                    ? currentBookyear.creditNoteNumberStartValue
                                    : currentBookyear.invoiceNumberStartValue, onChange: function (v) { return updateCurrent('creditNoteNumberFormat', v); } }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "col-sm-3 control-label" }, { children: intl.formatMessage(generalSettingsMessages.InvoiceNumberFormatYear) })), _jsx("div", __assign({ className: "col-sm-9" }, { children: _jsx(EnumSelect, { enumType: "numberFormatYear", value: numberFormatYear, onChange: function (v) { return setNumberFormatYear(v !== null && v !== void 0 ? v : 1); } }) }))] }))] })) })));
};
export default CreateLegalEntityModal;
